import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MuiThemeProvider } from '@material-ui/core/styles';

import AppInitLoading from './containers/appInitLoading/AppInitLoading';
import Snackbar from './containers/snackbar/Snackbar';
import LandingPage from './pages/LandingPage';
import OrganizationPage from './pages/OrganizationPage';
import BucketPage from './pages/BucketPage';

import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';

import * as organizationSelectors from './selectors/organizationSelectors';
import * as organizationConstants from './constants/organizations';
import routes from './helpers/ApplicationRoutes';
import theme from './helpers/Theme';

class App extends React.Component {
    componentDidMount() {
        const { organizations, fetchOrganizations } = this.props;
        if (!organizations) {
            fetchOrganizations();
        }
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <Provider store={this.props.store}>
                    <ConnectedRouter history={this.props.history}>
                        <React.Fragment>
                            <AppInitLoading />
                            <Snackbar />
                            <Route
                                exact
                                path={routes.root.path}
                                component={LandingPage}
                            />
                            <Switch>
                                <Route
                                    path={routes.bucket.path}
                                    component={BucketPage}
                                />
                                <Route
                                    path={routes.organization.path}
                                    component={OrganizationPage}
                                />
                            </Switch>
                        </React.Fragment>
                    </ConnectedRouter>
                </Provider>
            </MuiThemeProvider>
        );
    }
}

App.propTypes = {
    organizations: PropTypes.array,
    fetchOrganizations: PropTypes.func.isRequired,
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

App.defaultProps = {
    organizations: null,
};

const mapStateToProps = state => ({
    organizations: organizationSelectors.getOrganizations(state),
});

const mapDispatchToProps = dispatch => ({
    fetchOrganizations: () =>
        dispatch({ type: organizationConstants.FETCH_ORGANIZATIONS_REQUEST }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./src/App.js